import { ITag } from '../..';

export interface IAppsTags {
  appId: string;
  tags: ITag[];
}
